import { useEffect, useState } from "react"
import { Keyboard, Platform } from "react-native"

/**
 * Le clavier logiciel, pour une surface en position absolue (feuille,
 * panneau, calque) qui doit se replier elle-même : `KeyboardAvoidingView`
 * pousse ses enfants dans le flux, or une feuille ancrée par `bottom` n'y est
 * pas.
 *
 * - `open` : le clavier est ouvert.
 * - `lift` : de combien la surface doit remonter. La hauteur du clavier sur
 *   iOS ; 0 sur Android, où le cadre des barres système arrête déjà l'app au
 *   bord du clavier (SystemBarsFrame.android.js) — remonter en plus la
 *   décollerait d'une hauteur de clavier.
 *
 * Sur iOS on écoute les événements `will*` : ils sont émis AVANT l'animation
 * du clavier, si bien que la surface monte avec lui au lieu de le suivre d'un
 * cran. Android n'expose que les `did*`. Sur le web, `Keyboard.addListener`
 * de react-native-web est inerte : rien ne bouge, c'est le navigateur qui
 * gère le clavier virtuel.
 */
export function useKeyboardLift() {
    const [keyboardHeight, setKeyboardHeight] = useState(0)

    useEffect(() => {
        const showEvent =
            Platform.OS === "ios" ? "keyboardWillShow" : "keyboardDidShow"
        const hideEvent =
            Platform.OS === "ios" ? "keyboardWillHide" : "keyboardDidHide"

        const show = Keyboard.addListener(showEvent, (event) => {
            setKeyboardHeight(Math.max(0, event?.endCoordinates?.height ?? 0))
        })
        const hide = Keyboard.addListener(hideEvent, () => {
            setKeyboardHeight(0)
        })

        return () => {
            show?.remove?.()
            hide?.remove?.()
        }
    }, [])

    return {
        open: keyboardHeight > 0,
        lift: Platform.OS === "ios" ? keyboardHeight : 0,
    }
}
